import { useContext } from 'react';
import { RootLevelFlagsContext } from '../../contexts/RootLevelFlagContext/RootLevelFlagsContextProvider';

export function useAuth0AccessToken() {
  const { flags } = useContext(RootLevelFlagsContext);

  return flags.useAuth0AccessToken;
}
